import { render, staticRenderFns } from "./AccessPermissions.vue?vue&type=template&id=138a11cf"
import script from "./AccessPermissions.vue?vue&type=script&lang=js"
export * from "./AccessPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports